import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'home', component: () => import('../views/pool-stock-container.vue') },
  { path: '/login', login: 'home', component: () => import('@/views/login-index.vue') },
  { path: '/quant', login: 'quant', component: () => import('@/views/service/service-index.vue') }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
